import {B2BDocumentTypeList, DocumentTypeList, Invoice, InvoiceHistoryList, InvoicesFilter} from '../invoices.model';
import {Observable} from 'rxjs';

export abstract class CustomInvoiceAdapter {

  /**
   * Abstract method used to load Invoice data.
   *
   * @param userId The `userId` for given user
   * @param pageSize The `total results` per site
   * @param currentPage The  Actual page
   * @param sort The `sort` parameter
   * @param invoicesFilter The `filters` applied
   */
  abstract loadHistory(userId: string, pageSize: number, currentPage: number, sort: string, invoicesFilter: InvoicesFilter): Observable<InvoiceHistoryList>;

  /**
   * Abstract method used to load Invoice data.
   */
  abstract loadDocumentTypes(): Observable<B2BDocumentTypeList>;
}
